import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CheckIcon from "@mui/icons-material/Check";
interface Props {
  introductionValue: string;
  handleNext: () => void;
}

export function IntroductionContent({ introductionValue, handleNext }: Props) {
  return (
    <>
      <Typography>{introductionValue}</Typography>
      <Box sx={{ mb: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            onClick={handleNext}
            startIcon={<CheckIcon />}
            sx={{
              mt: 4,
              mr: 1,
              backgroundColor: "#0D548A",
              width: "7rem",
              "&:hover": {
                backgroundColor: "#0D548A",
              },
            }}
          >
            begin
          </Button>
        </Box>
      </Box>
    </>
  );
}
